import { Spin } from 'antd';

/**
 * Suspense fallback shown while a lazy-loaded route chunk streams in.
 * Sized to fill the AppShell content area so the layout doesn't jump.
 */
export function PageLoader() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40vh',
      }}
    >
      <Spin size="large" />
    </div>
  );
}
